import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const IntroPage = () => {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);
  const [isDay, setIsDay] = useState(true); // État pour gérer le fond (jour/nuit)

  useEffect(() => {
    // Animation du soleil vers la lune et changement de fond
    const transformTimer = setTimeout(() => {
      setIsDay(false); // Passer à la nuit après 2 secondes
    }, 2000);

    // Redirection après 5 secondes
    const redirectTimer = setTimeout(() => {
      setFadeOut(true); // Déclencher le fondu
      setTimeout(() => {
        navigate('/home'); // Rediriger après le fondu
      }, 1000); // Durée du fondu
    }, 5000);

    return () => {
      clearTimeout(transformTimer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center transition-all duration-1000 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      } ${
        isDay ? 'bg-gradient-to-b from-sky-200 to-sky-400' : 'bg-gradient-to-b from-blue-950 to-blue-900'
      }`}
    >
      {/* Animation du soleil qui se transforme en lune */}
      <div className="celestial-container">
        <div
          className={`celestial-body sun ${
            !isDay ? 'opacity-0' : 'opacity-100'
          }`}
        ></div>
        <div
          className={`celestial-body moon ${
            isDay ? 'opacity-0' : 'opacity-100'
          }`}
        ></div>
      </div>

      {/* Nuages animés (visible uniquement le jour) */}
      {isDay && (
        <div className="clouds">
          <div className="cloud cloud-1"></div>
          <div className="cloud cloud-2"></div>
          <div className="cloud cloud-3"></div>
        </div>
      )}

      {/* Message de bienvenue */}
      <div className="welcome-message mt-8 text-white text-4xl font-cursive animate-fade-in">
        Bienvenue sur Nurse de Nuit
      </div>

      {/* Étoiles en arrière-plan (visible uniquement la nuit) */}
      {!isDay && (
        <div className="stars">
          {[...Array(50)].map((_, index) => (
            <div
              key={index}
              className="star"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
              }}
            ></div>
          ))}
        </div>
      )}

      {/* Styles pour l'animation */}
      <style jsx>{`
        .celestial-container {
          width: 200px;
          height: 200px;
          position: relative;
        }

        .celestial-body {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          transition: opacity 1.5s ease-in-out;
        }

        .sun {
          background: radial-gradient(circle at 30% 30%, #ffdb58, #ffa500);
          box-shadow: 
            0 0 60px rgba(255, 215, 88, 0.8),
            0 0 100px rgba(255, 165, 0, 0.6),
            0 0 140px rgba(255, 165, 0, 0.4);
          position: relative;
        }

        .sun::after {
          content: '';
          position: absolute;
          top: -10%;
          left: -10%;
          width: 120%;
          height: 120%;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 10%, transparent 10.01%);
          background-size: 20px 20px;
          border-radius: 50%;
          animation: rotateSun 10s linear infinite;
        }

        @keyframes rotateSun {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .moon {
          background: #e0e0e0; /* Couleur de base de la lune */
          box-shadow: 
            0 0 20px rgba(224, 224, 224, 0.8),
            inset 10px 0 10px rgba(0, 0, 0, 0.2);
          mask: radial-gradient(
            circle at 70% 30%, /* Position du masque */
            transparent 45%, /* Partie transparente */
            black 45% /* Partie visible */
          );
        }

        .clouds {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .cloud {
          position: absolute;
          background: white;
          border-radius: 50%;
          opacity: 0.8;
          animation: floatCloud linear infinite;
        }

        .cloud-1 {
          width: 150px;
          height: 60px;
          top: 20%;
          left: -20%;
          animation-duration: 20s;
        }

        .cloud-2 {
          width: 200px;
          height: 80px;
          top: 40%;
          left: -30%;
          animation-duration: 25s;
        }

        .cloud-3 {
          width: 120px;
          height: 50px;
          top: 60%;
          left: -15%;
          animation-duration: 15s;
        }

        @keyframes floatCloud {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100vw);
          }
        }

        .welcome-message {
          opacity: 0;
          animation: fadeIn 1.5s ease-in-out forwards;
          animation-delay: 0.5s; /* Le message apparaît plus tôt */
          font-family: 'Dancing Script', cursive; /* Police cursive */
          font-size: 3rem; /* Taille du texte augmentée */
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Ombre du texte */
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .stars {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .star {
          position: absolute;
          width: 2px;
          height: 2px;
          background-color: white;
          border-radius: 50%;
          animation: twinkle 2s infinite ease-in-out;
        }

        @keyframes twinkle {
          0%, 100% {
            opacity: 0.5;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default IntroPage;